export default "__VITE_ASSET__dc915d7c__"